import React, {useState} from "react";
import {createStyles, makeStyles, useTheme, Theme} from "@material-ui/core/styles";
import Popover from '@material-ui/core/Popover';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import {Avatar} from "@material-ui/core";
import previews from './textures/map-preview';

import { useViewer } from "../hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonParent: {
      padding: "3px",
      background: "rgba(255,255,255,0.4)",
      position: 'absolute',
      bottom: "0.5em",
      left: "0.5em",
      zIndex: 10,
      borderRadius: "5px"
    },
    button: {
      padding: "0px !important",
      background: "rgba(0,60,136,0.5) !important",
      color: "white !important",
      minWidth: `${theme.spacing(3)}px  !important`,
      "&:hover": {
        background: "rgba(0,60,136,0.7)  !important"
      }
    },
    heading: {
      padding: theme.spacing(2),
    },
    icon: {
      width: "22px",
      height: "22px"
    },
    menuItem: {
      fontSize: "0.9em",
    },
    preview: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      marginRight: theme.spacing(2),
      borderRadius: theme.spacing(1)
    }
  }),
);

export const LayerSwitcher = (props) => {
  const {clearTooltipText} = props;

  const theme = useTheme();
  const classes = useStyles(theme);
  const {viewer} = useViewer();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    clearTooltipText();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (layerID) => {
    const minimap = viewer.minimap;
    minimap.setVisibleBasemap(layerID);
  };

  const getMenuItems = () => {
    const minimap = viewer.minimap;
    const layers = minimap.basemapIds;
    const selected = minimap.activeBasemap;

    return layers.map(layer => {
      return {
        id: layer.id,
        text: layer.text,
        icon: previews[layer.id],
        selected: layer.id === selected
      };
    });
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const options = viewer ? getMenuItems() : [];

  return (
    <div className={classes.buttonParent}>
      <Button
        aria-describedby={id}
        className={classes.button}
        onClick={handleClick}
      >
        <FormatListBulletedIcon className={classes.icon}/>
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {options.map(option => {
          return (
            <MenuItem
              key={option.id}
              className={classes.menuItem}
              selected={option.selected}
              onClick={() => {
                handleSelect(option.id);
                handleClose();
              }}
            >
              <Avatar src={option.icon} className={classes.preview} alt="icon"/>
              {option.text}
            </MenuItem>
          );
        })}
      </Popover>
    </div>
  );
};